module.exports = __webpack_public_path__ + "img/rda3.84807565.png";